import React, { useState } from 'react';
import { Container, TabButton, Wrapper } from './styled';
import { Link } from 'react-router-dom';

const CheerTab = ({ selectType }) => {
  return (
    <Container>
      <Wrapper>
        <TabButton isSelected={selectType === 'stat'}>
          <Link to="./stat">전력</Link>
        </TabButton>
        <TabButton isSelected={selectType === 'analysis'}>
          <Link to="./analysis">분석글</Link>
        </TabButton>
        <TabButton isSelected={selectType === 'odds'}>
          <Link to="./odds">배당</Link>
        </TabButton>
        <TabButton isSelected={selectType === 'lineup'}>
          <Link to="./lineup">라인업</Link>
        </TabButton>
        <TabButton isSelected={selectType === 'broadcast'}>
          <Link to="./broadcast">중계</Link>
        </TabButton>
        <TabButton isSelected={selectType === 'record'}>
          <Link to="./record">기록</Link>
        </TabButton>
      </Wrapper>
    </Container>
  );
};

export default CheerTab;
